import React from 'react';
import '../../../css/Grupo1/G1Landing.css';
import PacienteF from '../../../Component/Grupo5/PacienteF';


function Paciente(){

return(
      <div  >
        <PacienteF/>
      </div>

);


}
export default Paciente;